import { createApp } from "vue";
import {
  Alert,
  Avatar,
  Button,
  Card,
  Checkbox,
  Collapse,
  CollapseItem,
  Descriptions,
  DescriptionsItem,
  Divider,
  Doption,
  Drawer,
  Dropdown,
  Form,
  FormItem,
  Input,
  InputNumber,
  InputSearch,
  Layout,
  LayoutContent,
  LayoutHeader,
  Modal,
  Option,
  Radio,
  RadioGroup,
  Select,
  Space,
  Spin,
  Switch,
  TabPane,
  Tabs,
  Tag,
  Textarea,
  Timeline,
  TimelineItem,
} from "@arco-design/web-vue";
import {
  IconApps,
  IconCheck,
  IconDown,
  IconEdit,
  IconEmail,
  IconExport,
  IconFile,
  IconFilePdf,
  IconFolderAdd,
  IconIdcard,
  IconLeft,
  IconPhone,
  IconRefresh,
  IconRight,
  IconRobot,
  IconSafe,
  IconTrophy,
  IconUpload,
  IconUserGroup,
} from "@arco-design/web-vue/es/icon";
import "@arco-design/web-vue/dist/arco.css";
import "./styles.css";
import App from "./App.vue";
import { router } from "./router";

const app = createApp(App);
for (const [name, component] of Object.entries({
  AAlert: Alert,
  AAvatar: Avatar,
  AButton: Button,
  ACard: Card,
  ACheckbox: Checkbox,
  ACollapse: Collapse,
  ACollapseItem: CollapseItem,
  ADescriptions: Descriptions,
  ADescriptionsItem: DescriptionsItem,
  ADivider: Divider,
  ADoption: Doption,
  ADrawer: Drawer,
  ADropdown: Dropdown,
  AForm: Form,
  AFormItem: FormItem,
  AInput: Input,
  AInputNumber: InputNumber,
  AInputSearch: InputSearch,
  ALayout: Layout,
  ALayoutContent: LayoutContent,
  ALayoutHeader: LayoutHeader,
  AModal: Modal,
  AOption: Option,
  ARadio: Radio,
  ARadioGroup: RadioGroup,
  ASelect: Select,
  ASpace: Space,
  ASpin: Spin,
  ASwitch: Switch,
  ATabPane: TabPane,
  ATabs: Tabs,
  ATag: Tag,
  ATextarea: Textarea,
  ATimeline: Timeline,
  ATimelineItem: TimelineItem,
}))
  app.component(name, component);

for (const [name, component] of Object.entries({
  IconApps,
  IconCheck,
  IconDown,
  IconEdit,
  IconEmail,
  IconExport,
  IconFile,
  IconFilePdf,
  IconFolderAdd,
  IconIdcard,
  IconLeft,
  IconPhone,
  IconRefresh,
  IconRight,
  IconRobot,
  IconSafe,
  IconTrophy,
  IconUpload,
  IconUserGroup,
}))
  app.component(name, component);

app.use(router).mount("#app");
